import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        BOX: 'BOX',
        GROUP: 'GROUP',
        PRODUCT_SET: 'PRODUCT_SET',
      },
    }
  }
}
